import Form from "../Form";
import Components from "../Components";
import StickSidebar from "../StickSidebar";

export default function (el) {
	new StickSidebar($('.sl-checkout-sidebar .sidebar-inner', el));

	// Submit timeline
	var registerEvents = () => {
		var rules = [];


		new Form(el, rules, (form) => {
			Components.loading(el);
			$.ajax({
				method: "POST",
				url: wp.ajax_url,
				data: {
					action: 'sl_checkout_confirmation'
				}
			}).done((response) => {
				if(response.redirect) {
					window.location = response.redirect;
					return;
				}
			});
		});
	};

	registerEvents();
}
